module.exports = __webpack_public_path__ + "img/ts13.b4d9b6e5.png";